export * from './IconBookStroked';
